import React from 'react';

import { RBIChipsInput } from './../RBIChipsInput';
import { TreeSelector } from './TreeSelector';

export function TreeSelectorInput({
  label,
  nodes,
  classname = [],
  value,
  invariants = [],
  checkDisabled = (node: any) => false,
  onTreeNodesExpanded = (node: any[]) => {
    // No-op: Default implementation
  },
  onBeforeDelete = (item: any) => Promise.resolve(true),
  onChange = (node: any[]) => {
    // No-op: Default implementation
  },
  disabled = false,
  required = false,
}: any) {
  return (
    <RBIChipsInput
      label={label}
      value={value}
      invariants={invariants}
      disabled={disabled}
      containerStyle={{
        overflow: 'scroll',
        maxHeight: 250,
      }}
      required={required}
      externalClasses={classname}
      onChange={onChange}
      onBeforeDelete={onBeforeDelete}
    >
      <TreeSelector
        disabled={disabled}
        nodes={nodes}
        value={value}
        invariants={invariants}
        checkDisabled={checkDisabled}
        onNodeExpanded={onTreeNodesExpanded}
        onChange={onChange}
      />
    </RBIChipsInput>
  );
}
